<template>
  <a-card :bordered="false" class="card-area">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <!-- 搜索区域 -->
      <a-form layout="inline">
        <a-row :gutter="16">
          <!-- 第一行：常显搜索项（非时间选择器） -->
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item :label="$t('dashboard.order.barCodeNo')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-textarea
                  :placeholder="$t('dashboard.order.placeholderBarCodeNo')"
                  :autoSize="{minRows:1, maxRows:2}"
                  v-model="queryParam.barCodeNo"
                  allow-clear
                  style="width: 100%">
              </a-textarea>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item :label="$t('dashboard.order.wcBarCodeNo')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input
                  :placeholder="$t('dashboard.order.placeholderWcBarCodeNo')"
                  v-model="queryParam.wcBarCodeNo"
                  style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item :label="$t('dashboard.order.orderStatus')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-select
                  v-model="queryParam.orderStatus"
                  :placeholder="$t('dashboard.order.placeholderOrderStatus')"
                  style="width: 100%">
                <a-select-option v-for="(value, key) in dictEum" :key="key" :value="key">{{ value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item :label="$t('dashboard.order.toCustIdCardNo')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input
                  :placeholder="$t('dashboard.order.placeholderToCustIdCardNo')"
                  v-model="queryParam.toCustIdCardNo"
                  style="width: 100%"/>
            </a-form-item>
          </a-col>

          <!-- 第二行：可折叠搜索项（非时间选择器） -->
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.toCustLinkman')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderToCustLinkman')"
                    v-model="queryParam.toCustLinkman"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.toCustTel')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderToCustTel')"
                    v-model="queryParam.toCustTel"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.siteName')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    show-search
                    v-model="queryParam.siteName"
                    :placeholder="$t('dashboard.order.placeholderSiteName')"
                    style="width: 100%">
                  <a-select-option v-for="d in selectedItems" :key="d.id" :value="d.name">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.settlemenType')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    v-model="queryParam.settlemenType"
                    :placeholder="$t('dashboard.order.placeholdersettlemenType')"
                    style="width: 100%">
                  <a-select-option v-for="(value, key) in dictSettlemenTypeEum" :key="key" :value="key">
                    {{ value }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <!-- 第三行 -->
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.isPayment')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    v-model="queryParam.isPayment"
                    :placeholder="$t('dashboard.order.placeholderIsPayment')"
                    style="width: 100%">
                  <a-select-option value="0">未收款</a-select-option>
                  <a-select-option value="1">已收款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.waybillNumber')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-textarea
                    :placeholder="$t('dashboard.order.placeholderWaybillNumber')"
                    :autoSize="{minRows:1, maxRows:2}"
                    v-model="queryParam.waybillNumber"
                    allow-clear
                    style="width: 100%">
                </a-textarea>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.settlementCode')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderSettlementCode')"
                    v-model="queryParam.settlementCode"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.productCode')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderProductCode')"
                    v-model="queryParam.productCode"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <!-- 第四行 -->
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.sumBoxNum')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderSumBoxNum')"
                    v-model="queryParam.sumBoxNum"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.mainMailCode')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-textarea
                    :placeholder="$t('dashboard.order.placeholderMainMailCode')"
                    :autoSize="{minRows:1, maxRows:2}"
                    v-model="queryParam.mainMailCode"
                    allow-clear
                    style="width: 100%">
                </a-textarea>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.transactionId')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderTransactionId')"
                    v-model="queryParam.transactionId"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.paymentSource')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    v-model="queryParam.paymentSource"
                    :placeholder="$t('dashboard.order.placeholderPaymentSource')"
                    style="width: 100%">
                  <a-select-option value="现结">cash</a-select-option>
                  <a-select-option value="payme">payme</a-select-option>
                  <a-select-option value="WeChat">WeChat</a-select-option>
                  <a-select-option value="Alipay">Alipay</a-select-option>
                  <a-select-option value="pos">pos</a-select-option>
                  <a-select-option value="Uzumpal">Uzumpal</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.serviceType')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholdersServiceType')"
                    v-model="queryParam.serviceType"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.useDiscount')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    v-model="queryParam.useDiscount"
                    :placeholder="$t('dashboard.order.placeholderUseDiscount')"
                    style="width: 100%">
                  <a-select-option :value=1>是</a-select-option>
                  <a-select-option :value=0>否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.usePoints')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    v-model="queryParam.usePoints"
                    :placeholder="$t('dashboard.order.placeholderUsePoints')"
                    style="width: 100%">
                  <a-select-option :value=1>是</a-select-option>
                  <a-select-option :value=0>否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <!-- 时间选择器单独一行（每行3个） -->
            <a-col :md="8" :sm="12" :xs="24">
              <a-form-item :label="$t('antd.table.createTime')" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-range-picker
                    v-model="queryParam.createTimeRend"
                    style="width: 100%"
                    :show-time="{ format: 'HH:mm', defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')]}"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
                    @change="onCreatDateChange"
                    @ok="onDateOk"/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.outboundTime')" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-range-picker
                    v-model="queryParam.createTimeRange"
                    style="width: 100%"
                    :show-time="{ format: 'HH:mm',defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
                    @change="onDateChange"
                    @ok="onDateOk"/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.paymentTime')" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-range-picker
                    v-model="queryParam.payTimeRange"
                    style="width: 100%"
                    :show-time="{ format: 'HH:mm',defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
                    @change="onPayDateChange"
                    @ok="onDateOk"/>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator"
         style="margin-top: 5px; display: flex; justify-content: space-between; align-items: center;">
      <div style="flex: 1;">
        <a-button type="primary" icon="download" @click="handleAsyncExportXls()" :loading="exportLoading" style="margin-right: 8px;">
          {{ exportLoading ? '导出中...' : $t('antd.table.export') }}
        </a-button>
      </div>

      <div style="flex: 1; text-align: right;">
        <a-button type="primary" icon="search" @click="searchQuery(1)" style="margin-right: 8px;">
          {{ $t('antd.table.search') }}
        </a-button>
        <a-button icon="reload" @click="searchReset({},1)" style="margin-right: 8px;">
          {{ $t('antd.table.reset') }}
        </a-button>
        <a @click="handleToggleSearch">
          {{ toggleSearchStatus ? $t('antd.table.up') : $t('antd.table.down') }}
          <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
        </a>
      </div>
    </div>

    <!-- 统计信息区域 -->
    <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
      <div style="display: flex; gap: 20px; flex-wrap: wrap;">
        <div style="display: flex; align-items: center; gap: 5px">
          <span>{{ $t('dashboard.order.totalAmount') }}:</span>
          <span style="font-weight: 600; color: #2f54eb">{{ statistics.totalAmount }}</span>
          <span style="font-size: 0.8em; margin-left: 1px; color: #666">UZS</span>
        </div>
        <div style="display: flex; align-items: center; gap: 5px">
          <span>{{ $t('dashboard.order.totalPayAmount') }}:</span>
          <span style="font-weight: 600; color: #2f54eb">{{ statistics.totalPayAmount }}</span>
          <span style="font-size: 0.8em; margin-left: 1px; color: #666">UZS</span>
        </div>
        <div style="display: flex; align-items: center; gap: 5px">
          <span>{{ $t('dashboard.order.totalDiscountAmount') }}:</span>
          <span style="font-weight: 600; color: #2f54eb">{{ statistics.totalDiscountAmount }}</span>
          <span style="font-size: 0.8em; margin-left: 1px; color: #666">UZS</span>
        </div>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="table-container">
      <a-table
          ref="table"
          size="small"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :scroll="{ x: tableScrollX }"
          @change="handleTableChange"
      >
        <span slot="tags" slot-scope="tags">
          <a-tag
              :color="getTagColor(tags + '')">
            {{ aDouble(tags + '') }}
          </a-tag>
        </span>

        <span slot="paymentStatus" slot-scope="isPayment">
          <a-tag :color="isPayment == '0' ? 'red' : isPayment == '1' ? 'green' : ''">
            {{ paymentStatus(isPayment + '') }}
          </a-tag>
        </span>
        <span slot="paymentSource" slot-scope="text">
          <a-tag :color="paymentSourceColors[text] || 'default'">
            {{ text }}
          </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleInfor(record)">{{ $t('antd.table.infor') }}</a>
          <a-divider type="vertical"/>
          <a @click="showEditModal(record)">修改</a>
        </span>
      </a-table>
    </div>

    <!-- 表单区域 -->
    <a-drawer
        :title="drawerTitle"
        placement="right"
        :closable="true"
        :destroyOnClose="true"
        :width="1000"
        :bodyStyle="{ backgroundColor: '#cdcdcd' }"
        :visible="drawerVisible"
        :after-visible-change="afterVisibleChange"
        @close="onDrawerClose"
    >
      <OrderInfor
          :dictEum="dictEum"
          :dictSettlemenTypeEum="dictSettlemenTypeEum"
          :inforData="orderInforData"
          style="height:100%"
          ref="modalUserRole"
      />
    </a-drawer>

    <!-- 新增：修改支付状态对话框 -->
    <a-modal
        v-if="editModalVisible"
        title="修改支付状态"
        :visible="editModalVisible"
        @ok="handleEditOk"
        @cancel="handleEditCancel"
        :confirmLoading="confirmLoading"
    >
      <a-form :form="editForm">
        <!-- 新增：显示当前订单信息 -->
        <a-form-item label="订单编号" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
          <a-tag color="blue">{{ currentRecord.barCodeNo || '--' }}</a-tag>
        </a-form-item>

        <a-form-item label="原始收款状态" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
          <a-tag :color="currentRecord.isPayment == '0' ? 'red' : 'green'">
            {{ currentRecord.isPayment == '0' ? '未收款' : '已收款' }}
          </a-tag>
        </a-form-item>

        <a-form-item label="修改状态" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
          <a-select
              v-decorator="[
          'isPayment',
          {rules: [{ required: true, message: '请选择收款状态' }]}
        ]"
              placeholder="请选择收款状态"
              @change="handlePaymentStatusChange"
              :disabled="currentRecord.orderStatus == 2 && currentRecord.isPayment == '1'"
          >
            <a-select-option value="0">未收款</a-select-option>
            <a-select-option value="1">已收款</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="交易号" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
          <a-input
              v-decorator="['transactionId']"
              placeholder="请输入您的交易号"
          />
        </a-form-item>
        <a-form-item label="收款金额" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
          <a-input
              v-decorator="['payAmount']"
              type="number"
              placeholder="请输入您的收款金额"
          />
        </a-form-item>
        <a-form-item
            v-if="editForm.getFieldValue('isPayment') === '1'"
            label="收款时间"
            :labelCol="{span: 5}"
            :wrapperCol="{span: 19}"
        >
          <a-date-picker
              v-decorator="['paymentTime',{rules: [{ required: false }]}]"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              style="width: 100%"
              placeholder="请选择收款时间（可选）"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import {message} from 'ant-design-vue';
import OrderInfor from './modules/FinanceOrderInfo.vue'
import {dictGet, updatePaymentStatus} from 'api/app'
import {TableListMixin} from '@/situation/mixins/tableListMixin'
import {AsyncExportMixin} from '@/mixins/asyncExportMixin'
import {filterObj} from 'utils/util';
import {mapGetters} from 'vuex'

export default {
  name: "finance_order",
  mixins: [TableListMixin, AsyncExportMixin],
  components: {
    OrderInfor
  },
  computed: {
    aDouble() {
      return function (value) {
        return this.dictEum[value] ? this.dictEum[value] : ""
      }
    },
    paymentStatus() {
      return function (value) {
        if (value == '0') {
          return '未收款'
        } else if (value == 1) {
          return '已收款'
        } else {
          return '';
        }
      }
    },
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    tableScrollX() {
      // 计算所有列宽之和
      return this.columns.reduce((sum, col) => sum + (col.width || 120), 0)
    },
    getTagColor() {
      return function (value) {
        const colorMap = {
          '0': 'red',
          '1': 'green',
          '2': 'geekblue',
          '3': 'pink',
          '4': 'gold',
          '5': 'orange',
          '6': 'purple',
          '7': 'cyan',
          '8': 'gold'
        }
        return colorMap[value] || 'default'
      }
    },
  },
  async created() {
    const routeParam = this.$route.params

    if (routeParam.siteId) {
      this.queryParam.siteId = routeParam.siteId
    }

    if (routeParam.orderStatus) {
      this.queryParam.orderStatus = routeParam.orderStatus
    }

    if (routeParam.startTime) {
      this.queryParam.createTimeRend = [routeParam.startTime, routeParam.endTime]
    }

    let dictEum = await dictGet({
      dictType: ""
    })
    this.dictEum = dictEum.data.order_status
    this.dictSettlemenTypeEum = dictEum.data.settlemen_type
    await this.dataStatistics(); // 加载统计数据
  },
  beforeDestroy() {
    // 清理消息提示
    this.$message.destroy()
  },
  mounted() {
    this.selectedItemsAll = this.siteInfo()
    this.selectedItems = JSON.parse(JSON.stringify(this.selectedItemsAll))
  },
  data() {
    return {
      labelCol: {
        xs: {span: 1},
        sm: {span: 2},
      },
      wrapperCol: {
        xs: {span: 12},
        sm: {span: 18},
      },
      paymentSourceColors: {
        '现结': 'red',    // 微信红色系，用于现金交易
        'payme': 'geekblue',   // 微信绿色系，与主色相近
        'WeChat': 'green',  // 微信品牌绿色
        'Alipay': 'blue',  // 支付宝蓝色，与微信形成对比
        'pos': 'cyan',     // 微信黄色系，用于POS机
        'Uzumpal': 'gold'  // 紫色系，保持独特性
      },
      editModalVisible: false, // 控制编辑模态框显示
      confirmLoading: false, // 提交加载状态
      currentRecord: null, // 当前编辑的记录
      selectedItems: [],
      selectedItemsAll: [],
      dictEum: {},
      dictSettlemenTypeEum: {},
      orderInforData: {},
      drawerTitle: this.$t("dashboard.order.darcodeInfor"),
      drawerVisible: false,
      description: '角色管理页面',
      // 查询条件
      queryParam: {roleName: ''},
      editForm: this.$form.createForm(this), // 编辑表单
      payAmount: null,
      transactionId: '',
      // 表头
      columns: [
        {
          title: this.$t('dashboard.order.barCodeNo'),
          align: "center",
          dataIndex: 'barCodeNo',
          width: 150,
          fixed: 'left'
        }, {
          title: this.$t('dashboard.order.waybillNumber'),
          dataIndex: 'waybillNumber',
          align: "center",
          width: 180
        }, {
          title: this.$t('dashboard.order.siteName'),
          align: "center",
          dataIndex: 'siteName',
          width: 150
        },
        {
          title: this.$t('dashboard.order.orderStatus'),
          dataIndex: 'orderStatus',
          align: "center",
          width: 120,
          scopedSlots: {customRender: 'tags'},
        },
        {
          title: this.$t('dashboard.order.isPayment'),
          dataIndex: 'isPayment',
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'paymentStatus'},
        },
        {
          title: this.$t('dashboard.order.productCode'),
          dataIndex: 'productCode',
          align: "center",
          width: 120
        }, {
          title: this.$t('dashboard.order.transactionId'),
          dataIndex: 'transactionId',
          align: "center",
          width: 120
        }, {
          title: this.$t('dashboard.order.paymentSource'),
          dataIndex: 'paymentSource',
          scopedSlots: {customRender: 'paymentSource'},
          align: "center",
          width: 120
        }, {
          title: this.$t('dashboard.order.serviceCode'),
          dataIndex: 'serviceType',
          align: "center",
          width: 120
        },
        {
          title: this.$t('dashboard.order.inboundTime'),
          dataIndex: 'inboundTime',
          align: "center",
          width: 160
        },
        {
          title: this.$t('dashboard.order.outboundTime'),
          dataIndex: 'outboundTime',
          align: "center",
          width: 160
        },
        {
          title: this.$t('dashboard.order.createTime'),
          dataIndex: 'createTime',
          align: "center",
          width: 160
        },
        {
          title: this.$t('dashboard.order.paymentTime'),
          dataIndex: 'paymentTime',
          width: 160,
          align: "center"
        },
        {
          title: this.$t('dashboard.order.amount'),
          dataIndex: 'amount',
          width: 120,
          align: "center"
        },
        {
          title: this.$t('dashboard.order.payAmount'),
          dataIndex: 'payAmount',
          width: 120,
          align: "center"
        },
        {
          title: this.$t('dashboard.order.discountAmount'),
          dataIndex: 'discountAmount',
          width: 120,
          align: "center"
        },
        {
          title: this.$t('dashboard.order.pointsDiscountAmount'),
          dataIndex: 'pointsDiscountAmount',
          width: 120,
          align: "center"
        },
        {
          title: this.$t('antd.table.batch'),
          dataIndex: 'action',
          align: "center",
          width: 100,
          fixed: 'right',
          scopedSlots: {customRender: 'action'},
        }
      ],
      url: {
        selectData: "/ndt/order/page",
        statistics: "/ndt/order/finance/statistics",
        deleteData: "",
        exportTaskUrl: "/ndt/export/task/finance/async",
        exportStatusUrl: "/ndt/export/task/status",
        exportDownloadUrl: "ndt/export/task/download"
      }
    }
  },
  methods: {
    ...mapGetters(["siteInfo"]),
    handlePaymentStatusChange(value) {
      // 当状态切换为未收款时，清空支付时间
      if (value === '0') {
        this.editForm.setFieldsValue({
          paymentTime: null,
          transactionId: '',
          payAmount: null
        });
      }
    },
    // 显示编辑模态框
    showEditModal(record) {
      this.currentRecord = record
      this.editModalVisible = true
      this.$nextTick(() => {
        this.editForm.setFieldsValue({
          isPayment: record.isPayment.toString(),
          payAmount: record.payAmount ? Number(record.payAmount) : record.amount ? Number(record.amount) : null,
          transactionId: record.transactionId
        })
      })
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.current = this.ipagination.current;
      param.size = this.ipagination.pageSize;
      delete param.createTimeRange;
      delete param.createTimeRend;
      delete param.payTimeRange;
      if (this.superQueryParams) {
        param['superQueryParams'] = encodeURI(this.superQueryParams)
        param['superQueryMatchType'] = this.superQueryMatchType
      }
      return filterObj(param);
    },
    onDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.outboundStartTime = dateString[0];
      this.queryParam.outboundEndTime = dateString[1];
    },
    onCreatDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.startTime = dateString[0];
      this.queryParam.endTime = dateString[1];
    },
    onPayDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.paymentStartTime = dateString[0];
      this.queryParam.paymentEndTime = dateString[1];
    },
    onClose() {
      this.$refs.modalUserRole.close();
      this.drawerVisible = false
    },
    onDrawerClose() {
      this.drawerVisible = false
    },
    handleInfor(record) {
      this.drawerVisible = true
      this.orderInforData = record
    },
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    onChangeDate(date, dateString) {
      console.log(date, dateString);
    },
    onDateOk(value) {
      console.log(value);
    },

    // 编辑模态框确定
    handleEditOk() {
      this.editForm.validateFields(async (err, values) => {
        if (err) return;

        try {
          // 验证逻辑
          if (this.currentRecord.orderStatus == 2 && this.currentRecord.isPayment == 1 && values.isPayment == 0) {
            message.error('已签收、已支付订单不允许修改为未支付状态！');
            return;
          }

          if (this.currentRecord.isPayment == 0 && values.isPayment == 0) {
            message.error('未收款状态订单，修改时未改变收款状态，不需要进行更新。');
            return;
          }

          if (values.isPayment == 1) {
            if (values.payAmount == null || values.payAmount < 0 || values.payAmount == '') {
              message.error('实收金额不能小于0');
              return;
            }
            if (values.transactionId == null || values.transactionId.trim() == '') {
              message.error('请填写交易流水号');
              return;
            }
            // if (this.currentRecord.amount < values.payAmount) {
            //   message.error('实收金额不能大于订单金额');
            //   return;
            // }
          }

          // 准备请求参数
          const params = {
            barCodeNo: this.currentRecord.barCodeNo,
            isPayment: values.isPayment,
            paymentTime: values.paymentTime?.format('YYYY-MM-DD HH:mm:ss'),
            payAmount: values.payAmount,
            transactionId: values.transactionId,
          };

          this.confirmLoading = true;

          const res = await updatePaymentStatus(params);
          if (res.code === 200) {
            message.success('支付状态更新成功');
            this.loadData(); // 刷新表格数据
            this.dataStatistics(); // 刷新统计数据
            this.editModalVisible = false;
          } else {
            message.error(res.msg || '更新失败');
          }
        } catch (error) {
          message.error(error.message || '请求失败');
        } finally {
          this.confirmLoading = false;
        }
      });
    },

    // 编辑模态框确定
    // handleEditOk() {
    //   this.editForm.validateFields((err, values) => {
    //     if (!err) {
    //       if (this.currentRecord.orderStatus == 2) {
    //         if (values.isPayment == 0) {
    //           message.error('已签收、已支付订单不允许修改为未支付状态！');
    //           return;
    //         }
    //       }
    //       if (this.currentRecord.isPayment == 1) {
    //
    //       } else {
    //         if (values.isPayment == 0) {
    //           if (values.paymentTime == null || values.paymentTime == undefined) {
    //             message.error('未收款状态订单，修改时未改变收款状态');
    //             return;
    //           }
    //         }
    //       }
    //       if (values.isPayment == 1 && this.currentRecord.amount < values.payAmount) {
    //         message.error('实收金额不能大于订单金额');
    //         return;
    //       }
    //       // 格式化时间（如果存在）
    //       if (values.paymentTime) {
    //         values.paymentTime = values.paymentTime.format('YYYY-MM-DD HH:mm:ss');
    //       }
    //       this.confirmLoading = true
    //       const params = {
    //         barCodeNo: this.currentRecord.barCodeNo,
    //         isPayment: values.isPayment,
    //         paymentTime: values.paymentTime,
    //         payAmount: values.payAmount,
    //         transactionId: values.transactionId,
    //         // password: window.btoa(values.password)
    //       }
    //
    //       updatePaymentStatus(params).then(res => {
    //         if (res.code === 200) {
    //           message.success('支付状态更新成功')
    //           this.loadData() // 刷新表格数据
    //           this.dataStatistics() // 刷新统计数据
    //           this.editModalVisible = false
    //         } else {
    //           message.error(res.msg || '更新失败')
    //         }
    //       }).catch(error => {
    //         message.error(error.message || '请求失败')
    //       }).finally(() => {
    //         this.confirmLoading = false
    //       })
    //     }
    //   })
    // },
    // 编辑模态框取消
    handleEditCancel() {
      this.editModalVisible = false
      this.editForm.resetFields()
    },
  }
}
</script>
<style lang="less" scoped>
@import '~assets/less/common.less';

.table-container {
  width: 100%;
  overflow-x: auto;

  /deep/ .ant-table {
    min-width: 100%; /* 根据列宽总和设置最小宽度 */
    width: auto !important; // 让表格根据内容自动调整宽度
    .ant-table-tbody > tr > td {
      padding: 8px 12px; // 减小上下padding
      line-height: 1.3; // 减小行高
    }

    // 表头也可以相应调整
    .ant-table-thead > tr > th {
      padding: 8px 12px;
    }

    .ant-table-fixed {
      z-index: 2;
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px !important;
  }

  .table-page-search-wrapper {
    .ant-col {
      margin-bottom: 16px;
    }
  }

  .table-operator {
    margin-bottom: 16px;

    .ant-btn {
      margin-bottom: 8px;
    }
  }
}

/* 统计信息区域样式 */
.ant-alert-info {
  padding: 12px 16px;

  div {
    display: flex;
    align-items: center;

    a {
      margin-left: 4px;
      color: #1890ff;
    }
  }
}
</style>
